import { TableDividerVariantType } from '../variants';
export const getDefaultStyles = (FOUNDATIONS, FONT) => {
    return {
        [TableDividerVariantType.DEFAULT]: {
            container: {
                width: 'fit-content',
                background_color: FOUNDATIONS.color_neutral_bg_375,
                padding: FOUNDATIONS.color_comp_tableslist_lineseparator_regular_border,
                padding_top: `calc(${FOUNDATIONS.spacing_150} * 2)`,
            },
        },
    };
};
//# sourceMappingURL=default.js.map